import React from "react";

import { generateEmojiGrid } from "../../../lib/game-helpers";
import CountdownToNextPuzzle from "../../Countdown";
import ShareScoreButton from "../../ShareScore";
import BaseModal from "../BaseModal";
import { GameStatusContext } from "../../../providers/GameStatus";
import { PuzzleDataContext } from "../../../providers/PuzzleData";
import { Button } from "../../ui/button";

import { SolvedWordRow } from "../../GameGrid";

function ViewResultsModal() {
    const { submittedGuesses, isGameWon } = React.useContext(GameStatusContext);
    const { gameData } = React.useContext(PuzzleDataContext);

    const title = <span className="block w-full text-center">{isGameWon ? "You won the game!" : "You lost."}</span>;

    const content = isGameWon ? (
        <div className="flex flex-col items-center justify-center w-full">
            <p className="text-center font-medium text-lg mb-2">{"Great job, share your results!"}</p>
            <div className="flex flex-col items-center w-full">
                <span className="text-center whitespace-pre block">
                    {"\n"}
                    {generateEmojiGrid(gameData, submittedGuesses)}
                </span>
                <CountdownToNextPuzzle />
            </div>
        </div>
    ) : (
        <div className="flex flex-col gap-y-2 w-full">
            <p className="text-lg font-medium text-center">
                Better luck next time. The correct answers are below.
            </p>
            {gameData.map((obj) => (
                <SolvedWordRow key={obj.category} {...obj} />
            ))}
            <CountdownToNextPuzzle />
        </div>
    );

    return (
        <BaseModal
            title={title}
            trigger={
                <Button variant="submit" className="w-full" children={"View Results"} />
            }
            initiallyOpen={false}
            showActionButton={false}
            footerElements={<ShareScoreButton buttonText={isGameWon ? undefined : "Share Your Score!"} />}
        >
            {content}
        </BaseModal>
    );
}

export default ViewResultsModal;